import React from "react";
import styled from "styled-components/macro";

const StyledSpinner = styled.div`
  color: ${({ theme, color }) => (!color ? theme.primary : color)};
`;

const Spinner = ({
  type = "border",
  size = "",
  className = "",
  color = null,
}) => {
  const _type = type === "border" ? "spinner-border" : "spinner-grow";
  const _size = size === "sm" ? `spinner-${type}-sm` : "";
  return (
    <StyledSpinner
      className={`${_type} ${_size} ${className}`}
      role="status"
      color={color}
    >
      <span className="visually-hidden">Loading...</span>
    </StyledSpinner>
  );
};

export default Spinner;
